import { animate, group, style, transition, trigger } from '@angular/animations';

/**
 * Premium easing curves for natural motion
 * - ease-out-expo: Fast start, very smooth deceleration (feels snappy yet elegant)
 * - ease-in-out-quart: Symmetric acceleration/deceleration (natural for collapsing)
 */
const EASE_OUT_EXPO = 'cubic-bezier(0.16, 1, 0.3, 1)';
const EASE_IN_OUT_QUART = 'cubic-bezier(0.76, 0, 0.24, 1)';

export const slideUpDown = trigger('slideUpDown', [
    transition(':enter', [
        style({
            height: 0,
            opacity: 0,
            overflow: 'hidden',
        }),
        group([animate(`280ms ${EASE_OUT_EXPO}`, style({ height: '*' })), animate(`120ms ease-out`, style({ opacity: 1 }))]),
    ]),
    transition(':leave', [
        style({ overflow: 'hidden' }),
        group([animate(`220ms ${EASE_IN_OUT_QUART}`, style({ height: 0 })), animate(`180ms 40ms ease-in`, style({ opacity: 0 }))]),
    ]),
]);
